import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { Layout, Menu } from 'antd';
import { HomeOutlined, InfoCircleOutlined, FileTextOutlined, EditOutlined } from '@ant-design/icons';
import './App.css';

// 导入页面组件
import Home from './pages/Home';
import WritePost from './pages/WritePost';
import Archive from './pages/Archive';  // 从文件导入
import About from './pages/About';

const { Header, Content, Footer } = Layout;

function App() {
  const menuItems = [
    {
      key: 'home',
      icon: <HomeOutlined />,
      label: <Link to="/">首页</Link>,
    },
    {
      key: 'archive',
      icon: <FileTextOutlined />,
      label: <Link to="/archive">归档</Link>,
    },
    {
      key: 'write',
      icon: <EditOutlined />,
      label: <Link to="/write">写文章</Link>,
    },
    {
      key: 'about',
      icon: <InfoCircleOutlined />,
      label: <Link to="/about">我的</Link>,
    },
  ];

  return (
    <Router>
      <Layout className="layout">
        <Header style={{ position: 'fixed', zIndex: 1, width: '100%' }}>
          <div className="logo" style={{ float: 'left', color: 'white', fontSize: '18px', fontWeight: 'bold', marginRight: '40px' }}>
            我的博客
          </div>
          <Menu
            theme="dark"
            mode="horizontal"
            defaultSelectedKeys={['home']}
            items={menuItems}
            style={{ lineHeight: '64px' }}
          />
        </Header>
        <Content style={{ padding: '0 50px', marginTop: 64 }}>
          <div style={{ background: '#fff', padding: 24, minHeight: 380, borderRadius: '8px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/archive" element={<Archive />} />  {/* 这里使用导入的 Archive 组件 */}
              <Route path="/about" element={<About />} />
              <Route path="/write" element={<WritePost />} />
              {/* ❌ 删除这一行重复的 archive 路由 */}
              {/* <Route path="/archive" element={<Archive />} /> */}
              <Route path="/about" element={<About />} />
            </Routes>
          </div>
        </Content>
        <Footer style={{ textAlign: 'center', padding: '20px 50px' }}>
          <div style={{ borderTop: '1px solid #f0f0f0', paddingTop: '20px' }}>
            My Blog ©{new Date().getFullYear()} - 用 ❤️ 记录成长
          </div>
        </Footer>
      </Layout>
    </Router>
  );
}

export default App;